<template>
    <div class="user-multiple-form pt-5 marketplaces w-100">
        <div class="d-flex justify-content-center h-50 align-items-center" v-if="$store.state.loading">
            <b-spinner variant="info" style="width: 7rem; height: 7rem;"/>
        </div>
        <b-tabs v-if="secureUser"
                v-show="!$store.state.loading"
                align="center">
            <b-tab v-for="(item, key) in marketsData"
                   :key="key"
                   :active="$route.params.market === key"
                   :disabled="key === 'etsy' || key === 'ebay' || key === 'amazon'"
                   title-item-class="marketplaces__title">
                <template slot="title">
                    <img class="marketplaces__img"
                         :src="`/static/brand/${key}.png`"
                         :alt="`image-${key}`">
                </template>
                <market :market="{name: key, data: item}"
                        :codes="marketCodes[key] ? marketCodes[key] : {}"
                        @connectAccount="data => marketController(data)"
                        @removeIntegration="id => removeIntegration(id)"/>
            </b-tab>
        </b-tabs>
        <template v-else>
            <b-alert show variant="danger" class="ml-4 mr-4 w-75">
                Sorry, but we couldn't proceed with integration of products because of security reasons. Please,
                <b-btn variant="link" class="p-0 align-top" @click="$store.commit('LOGOUT')">Log Out</b-btn>
                and
                Log In to the Boxiti and choose
                <b>"Save me"</b> when login. It will save your access to the website
                during integration flow. You may change your settings when the integration is done.
            </b-alert>
        </template>
    </div>
</template>

<script>
    import amazonCodes from '@/assets/js/region-codes/amazon'
    import ebayCodes from '@/assets/js/region-codes/ebay'

    import Market from '~cp/UserPanel/Pages/UserSettings/Marketplaces/Market'

    export default {
        name: 'Marketplaces',
        components: {
            Market
        },
        data() {
            return {
                marketsData: {},
                marketCodes: {
                    amazon: amazonCodes,
                    ebay: ebayCodes
                },
            }
        },
        created() {
            this.getMarketsData()
        },
        computed: {
            secureUser: () => !!localStorage.getItem('refreshToken')
        },
        methods: {
            getMarketsData() {
                this.$api('GET', this.$endpoints.market()).then(response => {
                    this.marketsData = response
                })
            },
            connectMarket(path) {
                this.$store.commit('SET_LOADING', true)
                return this.$api('GET', this.$endpoints.market(path), null, null, false).then(response => response)
            },
            marketController(data) {
                switch (data.name) {
                    case 'shopify':
                        this.shopifyConnect(data.value)
                        break
                    case 'amazon':
                        if (data.value) {
                            this.amazonConnect(data.value)
                        } else {
                            this.saveAmazonData(data.amazon)
                        }
                        break
                    case 'ebay':
                        this.ebayConnect(data.value)
                        break
                    case 'etsy':
                        console.log('etsy', data.value)
                        break
                }
            },
            removeIntegration(id) {
                this.$api('DELETE', this.$endpoints.market(id)).then(response => {
                    this.marketsData = response
                })
            },
            shopifyConnect(shopName) {
                this.connectMarket(`shopify/${shopName}`).then(response => {
                    localStorage.setItem('shopifyTokenData', response.tokenData)
                    localStorage.setItem(`shopifyShopName`, shopName)
                    window.location.href = response.redirectLink
                })
            },
            amazonConnect(code) {
                this.connectMarket(`amazon/${code}`).then(response => {
                    window.open(response.redirectLink, '_blank')
                    this.$store.commit('SET_LOADING', false)
                })
            },
            saveAmazonData(amazon) {
                let body = {
                    mwsAuthToken: amazon.mwsAuthToken,
                    mwsSellerId: amazon.mwsSellerId
                }
                this.$api('PUT', this.$endpoints.market(`amazon/${amazon.code}`), body).then(response => {
                    this.marketsData = response
                })
            },
            ebayConnect(code) {
                this.connectMarket(`ebay/${code}`).then(response => {
                    localStorage.setItem('ebayTokenData', response.tokenData)
                    localStorage.setItem('ebayRegionCode', code)
                    window.location.href = response.redirectLink
                })
            },
            etsyConnect() {
                this.connectMarket('etsy').then(response => {
                    localStorage.setItem('etsyTokenData', response.tokenData)
                    window.location.href = response.redirectLink
                })
            },
        }
    }
</script>

<style lang="scss">
    .marketplaces {
        .tab-content {
            background: #fff;
        }
        &__title {
            .disabled img {
                filter: grayscale(100%);
            }

            img {
                max-width: 75px;
                width: 100%;
                display: block;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/UserSettings/Marketplaces/Marketplaces.vue